//@flow
import React, { useEffect } from 'react';
import { Grid, Container } from 'semantic-ui-react';
import { useDispatch, useSelector } from 'react-redux';
import { Routes, Route, useResolvedPath } from 'react-router';
import SideMenu from '../components/SideMenu';
import Settings from '../containers/Settings';
import MyOrders from '../components/MyOrders';
import { getOrders } from '../actions/user/orders';

const MyAccount = (): React$Node => {
  const dispatch = useDispatch();
  const currentUrl = useResolvedPath('').pathname;
  const orders = useSelector((state) => state.orders.orders);

  useEffect(() => {
    dispatch(getOrders());
  }, [dispatch]);

  const items = [
    {
      label: 'My Details',
      path: `/my-account/details`,
      container: () => <Settings />,
      icon: 'product',
    },
    {
      label: 'My Orders',
      path: `/my-account/orders`,
      container: () => <MyOrders orders={orders} />,
      icon: 'details',
    },
  ];

  return (
    <Container className="my-account-page">
      <Grid className="side-menu-layout">
        <Grid.Column
          mobile={12}
          tablet={3}
          computer={3}
          className="side-menu-column"
        >
          <SideMenu currentPath={currentUrl} items={items} />
        </Grid.Column>
        <Grid.Column mobile={12} tablet={9} computer={9}>
          <Grid>
            <Grid.Column>
              <Routes>
                {items.map((item, index) => {
                  return (
                    <Route
                      key={index}
                      path={item.path.split('/').pop()}
                      element={item.container()}
                    />
                  );
                })}
              </Routes>
            </Grid.Column>
          </Grid>
        </Grid.Column>
      </Grid>
    </Container>
  );
};

export default MyAccount;
